module.exports = __webpack_public_path__ + "bf4269ade99560f83f92bf6809b485cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/maestro.png
// module id = 520
// module chunks = 0